import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import '@uchi/tokens-0-4/css/tokens.css';
import '@uchi/dino-styles';
import '@uchi/dino-button/build/main.css';
import '@uchi/dino-input/build/main.css';
import '@uchi/dino-text/build/main.css';
import './index.css';
import App from './app/App.tsx';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')!,
);
